import {
  AlertIcon,
  Banner,
  Box,
  Flex,
  InfoIcon,
  Typography,
} from '@iheartjane/reefer';
import { useState } from 'react';
import { useFormContext } from 'react-hook-form';

import { useFetchCurrentBloomMenu } from '@jane/business-admin/data-access';

import { ImageUploader } from '../../ImageUploader';

export const LogoSection = () => {
  const [imageErrors, setImageErrors] = useState<(string | boolean)[]>();
  const bloomMenuQuery = useFetchCurrentBloomMenu();
  const formMethods = useFormContext();
  const { setValue, watch } = formMethods;
  const imageUrl = watch('logo');

  return (
    <Box>
      <Typography mb={16}>
        Upload your logo that will appear in the header of your homepage
      </Typography>

      {imageErrors?.map((error, i) => (
        <Banner
          full
          mb={16}
          icon={<AlertIcon />}
          label={error}
          variant="error"
          onDismiss={() =>
            setImageErrors(imageErrors.filter((e) => e !== error))
          }
          key={i}
        />
      ))}

      <ImageUploader
        height={264}
        width="100%"
        imageUrl={imageUrl}
        isLoading={bloomMenuQuery.isPending || bloomMenuQuery.isFetching}
        onError={setImageErrors}
        onUpdateImage={(imageUrl: string) =>
          setValue('logo', imageUrl, { shouldDirty: true })
        }
      />

      <Flex alignContent="center" mt={12}>
        <InfoIcon
          size="sm"
          mr={12}
          mt={4}
          color="grays-mid"
          style={{ flexShrink: 0 }}
        />
        <Typography variant="mini" color="grays-mid">
          Upload a JPG or PNG under 2MB. Your new logo will appear after you
          publish; until then, Preview will show your current logo.
        </Typography>
      </Flex>
    </Box>
  );
};
